export default __webpack_public_path__ + "static/media/67.245286f8.jpg";